import React from "react";
import { useEffect, useState } from "react";
import { BarChart, Bar, Tooltip, XAxis, YAxis } from "recharts";
import { fetchJson } from "../authProvider";
import moment from "moment/moment";
import {
  Box,
  Button,
  Container,
  Stack,
  TextField,
  Typography,
  Card,
} from "@mui/material";

export default function App() {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const data = [];
  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  useEffect(() => {
    fetchJson("https://api.carbonvoice.app/admin/message/statistics").then(
      (result) => {
        console.log("got result?");
        for (var instance of result.json) {
          var date = moment(instance.date);
          var row = {
            date: date.format("MMM D"),
            canceled: instance.messages[ "canceled" ] ?? 0,
            deleted: instance.messages[ "deleted" ] ?? 0,
            active: instance.messages["active"] ?? 0,
            inprogress: instance.messages["inprogress"] ?? 0,
            processing: instance.messages["processing"] ?? 0,
            initializing: instance.messages[ "initializing" ] ?? 0,
            failed: instance.messages["failed"] ?? 0,
            offline: instance.messages["offline"] ?? 0,
          };

          
          //don't include in progress if the date is today.
          if ( date.isSame( moment(), 'day' ) ) {
            row.bad = row.processing + row.initializing + row.failed + row.offline;
            
          } else {
            row.bad = row.inprogress + row.processing + row.initializing + row.failed + row.offline;
          }

          row.deletedOrCanceled = row.deleted + row.canceled;
          row.total = row.active + row.bad + row.deletedOrCanceled;
          if (row.total > 0 && row.bad > 0) {
            row.badPercent = ( row.bad / row.total ) * 100;
          } else {
            row.badPercent = 0;
          }

          row.deletedOrCanceledPercent = 0;
          if (row.total > 0 && row.deletedOrCanceled > 0) {
            row.deletedOrCanceledPercent = ( row.deletedOrCanceled / row.total ) * 100;
          }

          row.offlinePercent = 0;
          if (row.total > 0 && row.offline > 0) {
            row.offlinePercent = ( row.offline / row.total ) * 100;
          }

          data.push(row);
        }
        setItems(data);
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    );
  }, []);
  return (
    <Box>
      <h3>Messages Per Day</h3>
      <Card>
        <BarChart
          width={1600}
          height={400}
          margin={{ top: 50, right: 30, left: 20, bottom: 5 }}
          data={items}
          syncId={"anyId"}
        >
          <Tooltip />
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" />
          <Bar
            dataKey="inprogress"
            fill="#100bb0ff"
            yAxisId="left"
            stackId={"stack"}
          />
           <Bar
            dataKey="failed"
            fill="#dc0505ff"
            yAxisId="left"
            stackId={"stack"}
          />
          <Bar
            dataKey="canceled"
            fill="#eb6918ff"
            yAxisId="left"
            stackId={"stack"}
          />
          <Bar
            dataKey="deleted"
            fill="#000000ff"
            yAxisId="left"
            stackId={"stack"}
          />
          <Bar
            dataKey="processing"
            fill="#cbd818ff"
            yAxisId="left"
            stackId={"stack"}
          />
          <Bar
            dataKey="offline"
            //yellow
            fill="#ffff00ff"
            yAxisId="left"
            stackId={"stack"}
          />
          <Bar
            dataKey="initializing"
            fill="#AAAA00"
            yAxisId="left"
            stackId={"stack"}
          />
          <Bar
            dataKey="active"
            fill="#148014ff"
            yAxisId="left"
            stackId={"stack"}
          />
        </BarChart>
          </Card>
          <h3>Bad Message %</h3>
      <Card>
        
        <BarChart
          width={1600}
          height={200}
          margin={{ top: 50, right: 30, left: 20, bottom: 5 }}
          data={items}
          syncId={"anyId"}
        >
          <Tooltip />
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" />
          <Bar dataKey="badPercent" fill="#0000AA" yAxisId="left" />
        </BarChart>
      </Card>
      <h3>Deleted or Canceled Messages %</h3>
      <Card>
        <BarChart
          width={1600}
          height={200}
          margin={{ top: 50, right: 30, left: 20, bottom: 5 }}
          data={items}
          syncId={"anyId"}
        >
          <Tooltip />
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" />
          <Bar dataKey="deletedOrCanceledPercent" fill="#0000AA" yAxisId="left" />
        </BarChart>
      </Card>
      <h3>Offline Messages %</h3>
      <Card>
        <BarChart
          width={1600}
          height={200}
          margin={{ top: 50, right: 30, left: 20, bottom: 5 }}
          data={items}
          syncId={"anyId"}
        >
          <Tooltip />
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" />
          <Bar dataKey="offlinePercent" fill="#0000AA" yAxisId="left" />
        </BarChart>
      </Card>
    </Box>
  );
}
